"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var util_localization_1 = require("@sport-thieme/util-localization");
var react_1 = require("react");
var react_2 = require("react");
var getDefaultSnake = function (gameSize) { return [
    [(46 / 100) * gameSize, (50 / 100) * gameSize],
    [(47 / 100) * gameSize, (50 / 100) * gameSize],
    [(48 / 100) * gameSize, (50 / 100) * gameSize],
    [(49 / 100) * gameSize, (50 / 100) * gameSize],
    [(50 / 100) * gameSize, (50 / 100) * gameSize],
]; };
function SnakeGame(_a) {
    var _b;
    var _c = _a.size, size = _c === void 0 ? 600 : _c, _d = _a.gameSize, gameSize = _d === void 0 ? 50 : _d;
    var board = react_1.useRef(null);
    var _e = react_1.useState(false), isRunning = _e[0], setIsRunning = _e[1];
    var _f = react_1.useState(false), boom = _f[0], setBoom = _f[1];
    var _g = react_1.useState(50), speed = _g[0], setSpeed = _g[1];
    var _h = react_1.useState('d'), direction = _h[0], setDirection = _h[1];
    var _j = react_1.useState(undefined), food = _j[0], setFood = _j[1];
    var _k = react_1.useState(0), score = _k[0], setScore = _k[1];
    var _l = react_1.useState(parseInt((_b = localStorage.getItem('snakeHighscore')) !== null && _b !== void 0 ? _b : '0')), highscore = _l[0], setHighscore = _l[1];
    var _m = react_1.useState(function () { return getDefaultSnake(gameSize); }), snake = _m[0], setSnake = _m[1];
    var classes = useStyles({ size: size, boom: boom });
    var addFood = react_2.useCallback(function () {
        var nextFood = [
            Math.round(Math.random() * (gameSize * 0.95)),
            Math.round(Math.random() * (gameSize * 0.95)),
        ];
        if (snake.find(function (coord) { return coord[0] === nextFood[0] && coord[1] === nextFood[1]; }) === undefined) {
            setFood(nextFood);
        }
        else {
            addFood();
        }
    }, [snake]);
    react_1.useEffect(function () { return addFood(); }, []);
    var path = react_1.useMemo(function () {
        return snake.map(function (_a, i) {
            var x = _a[0], y = _a[1];
            return "" + (i === 0 ? 'M' : 'L') + x + " " + y;
        }).join('');
    }, [snake]);
    var resetGame = react_2.useCallback(function () {
        if (boom === false)
            return;
        console.log('Reset');
        setBoom(false);
        setSnake(getDefaultSnake(gameSize));
        setIsRunning(false);
        setScore(0);
        setSpeed(50);
        setDirection(function () { return 'd'; });
        addFood();
    }, [setBoom, setSnake, setIsRunning, setScore, setSpeed, setDirection, addFood, boom]);
    var updateSnake = react_2.useCallback(function () {
        if (isRunning === false || boom)
            return;
        var _a = snake[snake.length - 1], x = _a[0], y = _a[1];
        var nextHead;
        switch (direction) {
            case 'd':
                nextHead = [x, y + 1];
                break;
            case 'r':
                nextHead = [x + 1, y];
                break;
            case 'l':
                nextHead = [x - 1, y];
                break;
            case 'u':
                nextHead = [x, y - 1];
                break;
        }
        var crashedSelf = snake.slice(0, snake.length - 2).find(function (_a) {
            var x = _a[0], y = _a[1];
            return x === nextHead[0] && y === nextHead[1];
        }) !==
            undefined;
        var nextX = nextHead[0], nextY = nextHead[1];
        var wallCrash = nextX < 1 || nextX > gameSize - 1 || nextY < 1 || nextY > gameSize - 1;
        var newSnake = __spreadArrays(snake, [nextHead]);
        if ((food === null || food === void 0 ? void 0 : food[0]) !== nextX || (food === null || food === void 0 ? void 0 : food[1]) !== nextY) {
            newSnake.shift();
        }
        else {
            setSpeed(speed - 0.5);
            addFood();
            setScore(score + 100);
        }
        setSnake(newSnake);
        if (crashedSelf || wallCrash) {
            if ((highscore !== null && highscore !== void 0 ? highscore : 0) < score) {
                localStorage.setItem('snakeHighscore', score.toString());
                setHighscore(score);
            }
            setBoom(true);
            setIsRunning(false);
        }
    }, [direction, snake, isRunning, food, addFood]);
    react_1.useEffect(function () {
        var interval = setInterval(updateSnake, speed);
        return function () { return clearInterval(interval); };
    }, [updateSnake, speed]);
    var keydownListener = react_2.useCallback(function (event) {
        if (event.key.includes('Arrow') && boom === false) {
            setIsRunning(true);
        }
        switch (event.key) {
            case ' ':
                resetGame();
                break;
            case 'ArrowDown':
                event.preventDefault();
                event.stopPropagation();
                if (direction !== 'u')
                    setDirection('d');
                break;
            case 'ArrowUp':
                event.preventDefault();
                event.stopPropagation();
                if (direction !== 'd')
                    setDirection('u');
                break;
            case 'ArrowLeft':
                event.preventDefault();
                event.stopPropagation();
                if (direction !== 'r')
                    setDirection('l');
                break;
            case 'ArrowRight':
                event.preventDefault();
                event.stopPropagation();
                if (direction !== 'l')
                    setDirection('r');
                break;
        }
    }, [direction, setIsRunning, resetGame]);
    react_1.useEffect(function () {
        window.addEventListener('keydown', keydownListener);
        return function () {
            window.removeEventListener('keydown', keydownListener);
        };
    }, [keydownListener]);
    return (jsx_runtime_1.jsxs("svg", __assign({ ref: board, viewBox: "0 0 50 50", id: "snake", className: classes.svg }, { children: [jsx_runtime_1.jsx("rect", { className: classes.playground, x: "0.5", y: "0.5", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1", width: gameSize - 1, height: gameSize - 1 }, void 0),
            jsx_runtime_1.jsx("path", { d: path, className: classes.snake, strokeLinecap: "round", strokeLinejoin: "round", fill: "none" }, void 0),
            food && jsx_runtime_1.jsx("circle", { cx: food[0], cy: food[1], r: 0.5, className: classes.food }, void 0),
            jsx_runtime_1.jsxs("text", __assign({ x: gameSize * 0.96, y: gameSize * 0.96, className: classes.text, textAnchor: "end", fontSize: "3" }, { children: [jsx_runtime_1.jsxs("tspan", __assign({ x: gameSize * 0.96 }, { children: [util_localization_1.localize(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Score"], ["Score"]))), ": ", score] }), void 0),
                    jsx_runtime_1.jsxs("tspan", __assign({ x: gameSize * 0.96, dy: "-3" }, { children: [util_localization_1.localize(templateObject_2 || (templateObject_2 = __makeTemplateObject(["Personal best"], ["Personal best"]))), ": ", highscore] }), void 0)] }), void 0),
            boom && (jsx_runtime_1.jsxs("text", __assign({ x: gameSize * 0.5, y: gameSize * 0.5, className: classes.text, textAnchor: "middle", fontSize: "3" }, { children: [jsx_runtime_1.jsx("tspan", __assign({ x: gameSize * 0.5 }, { children: util_localization_1.localize(templateObject_3 || (templateObject_3 = __makeTemplateObject(["Game over"], ["Game over"]))) }), void 0),
                    jsx_runtime_1.jsx("tspan", __assign({ x: gameSize * 0.5, dy: "3" }, { children: util_localization_1.localize(templateObject_4 || (templateObject_4 = __makeTemplateObject(["Press space to play again"], ["Press space to play again"]))) }), void 0)] }), void 0))] }), void 0));
}
exports.default = SnakeGame;
var useStyles = core_1.makeStyles(function (theme) { return ({
    svg: {
        width: function (_a) {
            var size = _a.size;
            return size;
        },
        height: function (_a) {
            var size = _a.size;
            return size;
        },
        maxWidth: '100vw',
        maxHeight: '100vh',
    },
    snake: {
        stroke: function (_a) {
            var boom = _a.boom;
            return (boom ? theme.palette.error.contrastText : theme.palette.primary.main);
        },
    },
    food: {
        fill: function (_a) {
            var boom = _a.boom;
            return (boom ? theme.palette.error.contrastText : theme.palette.secondary.main);
        },
    },
    text: {
        fill: function (_a) {
            var boom = _a.boom;
            return (boom ? theme.palette.error.contrastText : theme.palette.text.primary);
        },
    },
    playground: {
        fill: function (_a) {
            var boom = _a.boom;
            return (boom ? theme.palette.error.main : theme.palette.background.paper);
        },
        stroke: theme.palette.primary.main,
    },
}); });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=SnakeGame.js.map